import { useContext, useEffect, useState } from 'react';
import { Modal, ModalTextInput, Button } from '../components';
import { PromptContext } from '../contexts/PromptContext';

export const Prompt = () => {
  const [prompt, setPrompt] = useContext(PromptContext);
  const [input, setInput] = useState('');
  const {
    isOpen,
    props: { text, title, value, isInput, onSubmit },
  } = prompt;

  const closePrompt = () => setPrompt({ ...prompt, isOpen: false });
  useEffect(() => {
    value && setInput(value);
  }, [isOpen, value]);

  return (
    <Modal isOpen={isOpen}>
      <div className="flex h-screen flex-col items-center justify-center">
        <Modal.Header>{title}</Modal.Header>
        <Modal.Body>
          <span>{text}</span>
          {isInput && (
            <ModalTextInput
              onChange={(e: React.FormEvent<HTMLInputElement>) => setInput(e.currentTarget.value)}
              value={input}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="submit"
            id="prompt-submit"
            onClick={() => {
              const emailCorrect = confirm(
                `You submitted: ${input} as your email address. Click OK to continue or Cancel to re-enter.`,
              );
              if (emailCorrect) {
                onSubmit(input);
                closePrompt();
              } else {
                return;
              }
            }}
            textContent="Submit"
          />
          <Button type="button" id="prompt-cancel" onClick={closePrompt} textContent="Cancel" />
        </Modal.Footer>
      </div>
    </Modal>
  );
};
